/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Events_EmptyInputs */



/**
* | output |
* | --- |
* | "No revenue recorded for this customer yet." |
*
* @param {Partner_Admin_Commission_Events_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_events_empty = /** @type {((inputs?: Partner_Admin_Commission_Events_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Events_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für diesen Kunden wurden noch keine Umsätze erfasst.")
	return /** @type {LocalizedString} */ ("No revenue recorded for this customer yet.")
});